import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Registry } from '@/registry.service';
import { DialogPopUpComponent } from '@components/dialog-pop-up/dialog-pop-up.component';
import { LoggerService } from '@services/logger.service';
import { Component, OnInit } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { ToastrService } from 'ngx-toastr';
import { BankAccountModel } from '@/models/tables/bank-account.model';
import { BankAccountService } from '@services/data-source-tables/bank-account.service';

@Component({
  selector: 'app-button-bank-account-delete',
  templateUrl: '../../button.component.html',
  styleUrls: ['../../button.component.scss'],
})
export class ButtonDeleteBankAccountComponent extends ButtonComponent implements OnInit {
  faIcon = faTrashCan;
  private bankAccount: BankAccountModel;
  private rowData: any;

  constructor(
    protected router: Router,
    public dialog: MatDialog,
    protected bankAccountService: BankAccountService,
    protected toastr: ToastrService,
  ) {
    super(router, toastr);

    this.color = 'danger';
    this.additionalClass = 'py-0.5 px-2.5';
    this.showIcon = true;
    this.smallBtn = true;
  }

  ngOnInit() {
    this.bankAccount = <BankAccountModel>this.rowData;
  }

  /**
   * Delete user
   */
  public actionClick(): void {
    let dialogRef = this.dialog.open(DialogPopUpComponent, {
      width: 'auto',
      panelClass: 'custom-modalbox',
    });

    this.setupPopup(dialogRef);

    dialogRef.afterClosed().subscribe((deleteSubAgent) => {
      if (deleteSubAgent) {
        this.bankAccountService.deleteBankAccount(this.bankAccount.id).subscribe({
          next: () => {
            this.toastr.success('Banca cancellata correttamente!');

            Registry.getInstance().get('BankAccountComponent').loadBankAccount();
          },
          error: (error) => {
            LoggerService.error('deleteBankAccount failed!');
            LoggerService.error(error);

            this.toastr.error(`Errore durante la cancellazione della Banca.`);
          },
          complete: () => {
            LoggerService.log('Request done');
          },
        });
      }
    });
  }

  private setupPopup(dialogRef: MatDialogRef<DialogPopUpComponent>) {
    dialogRef.componentInstance.title = 'Confermi di voler cancellare questa Banca?';
    dialogRef.componentInstance.content =
      'Attenzione una volta cancellata questa Banca non sarà più possibile recuperarla.';
    dialogRef.componentInstance.firstCTA = 'Si cancella';
    dialogRef.componentInstance.secondCTA = 'Annulla operazione';
    dialogRef.componentInstance.closeResultFirst = true;
    dialogRef.componentInstance.closeResultSecond = false;
  }
}
